import React from "react";
import CommunityListPage from "../community/components/CommunityListPage";
import { ASK_FOR_HELP } from "../community/constants";
import { useRequireSectionVisible } from "../../client/hooks/useRequireSectionVisible";

export default function AskForHelpPage() {
  useRequireSectionVisible("showAskForHelp");
  return <CommunityListPage section={ASK_FOR_HELP} />;
}
